<h2 class="bd-title">Notification Settings</h2>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (notificationProfileCount > 0 && isSaaS) {
<alert type="info">
  <coso-alert-message> You can configure your email profiles <a class="underline-link" [routerLink]="emailNotificationProfilesLink">here</a>. </coso-alert-message>
</alert>
} @if (notificationProfileCount === 0) {
<alert type="warning">
  <coso-alert-message>
    You do not have any alert notification profile configured. You can configure one <a class="underline-link" [routerLink]="emailNotificationProfilesLink">here</a>.
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) { @if ({ isLoading: loadingService.isSpinnerActive$('loadEmailProfiles') | async }; as loadingState) { @if (!loadingState.isLoading) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label id="notificationEmailProfileNameLabel" for="notificationEmailProfileName" class="cs-larger-text cs-bolder-text">Alert notification profile</label>
      <div id="notificationEmailProfileNameSubLabel" class="cs-secondary-text">Select which alert notification profile to use.</div>
    </div>
    <div class="cs-input-wrapper">
      <select
        class="form-control"
        id="notificationEmailProfileName"
        name="notificationEmailProfileName"
        aria-describedby="notificationEmailProfileNameSubLabel"
        [(ngModel)]="selectedProfileName"
        (ngModelChange)="updateProfile(settings, $event)"
        [disabled]="readonly$ | async"
      >
        <option [ngValue]="''" disabled>Select a profile</option>
        @if (isSaaS) {
        <option [ngValue]="default">Reset profile</option>
        } @for (profile of profiles; track profile) {
        <option [ngValue]="profile.name">{{ profile.name }}</option>
        }
      </select>
    </div>
  </div>
  } }
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label for="cumulativeLimit" id="cumulativeLimitLabel" class="cs-larger-text cs-bolder-text">Cumulative notification limit</label>
      <div id="cumulativeLimitSubLabel" class="cs-secondary-text">Set the amount of time (in minutes) that notifications will be stored before all are sent out.</div>
    </div>
    <div class="cs-input-wrapper">
      <input
        type="number"
        class="form-control"
        id="cumulativeLimit"
        name="cumulativeLimit"
        #cumulativeAlertLimit="ngModel"
        required
        [min]="isSaaS ? 15 : 1"
        max="1439"
        [class.is-invalid]="cumulativeAlertLimit.touched && cumulativeAlertLimit.invalid"
        cosoRangeValidator
        [attr.aria-invalid]="cumulativeAlertLimit.invalid"
        [attr.aria-describedby]="'cumulativeLimitSubLabel' + (cumulativeAlertLimit.touched && cumulativeAlertLimit.invalid ? ' cumulativeLimit-errors' : '')"
        [(ngModel)]="cumulativeLimit"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
      />
      <span class="fa fa-times invalid-feedback-icon" aria-hidden="true"></span>
      @if (cumulativeAlertLimit.touched && cumulativeAlertLimit.invalid) { @if (cumulativeAlertLimit.errors?.min) {
      <div class="invalid-feedback" id="cumulativeLimit-errors" role="alert">
        The Cumulative notification limit field must be greater than or equal to 1.
      </div>
      } @if (cumulativeAlertLimit.errors?.max) {
      <div class="invalid-feedback" id="cumulativeLimit-errors" role="alert">
        The Cumulative notification limit field must be less than or equal to 1439.
      </div>
      } @if (cumulativeAlertLimit.errors?.required) {
      <div class="invalid-feedback" id="cumulativeLimit-errors" role="alert">
        The Cumulative notification limit field is required.
      </div>
      } }
    </div>
  </div>
  @if (isSaaS && notificationTypes.includes('OnExpiringLicense')) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label for="daysBeforeLicenseExpiry" id="daysBeforeLicenseExpiryLabel" class="cs-larger-text cs-bolder-text">Days before expiry limit</label>
      <div id="daysBeforeLicenseExpirySubLabel" class="cs-secondary-text">Set the amount of days before subscription expiration to be notified.</div>
    </div>
    <div class="cs-input-wrapper">
      <input
        type="number"
        class="form-control"
        id="daysBeforeLicenseExpiry"
        name="daysBeforeLicenseExpiry"
        #daysBeforeExpiry="ngModel"
        required
        min="1"
        max="365"
        [class.is-invalid]="daysBeforeExpiry.touched && daysBeforeExpiry.invalid"
        cosoRangeValidator
        [attr.aria-invalid]="daysBeforeExpiry.invalid"
        [attr.aria-describedby]="'daysBeforeLicenseExpirySubLabel' + (daysBeforeExpiry.touched && daysBeforeExpiry.invalid ? ' daysBeforeLicenseExpiry-errors' : '')"
        [(ngModel)]="daysBeforeLicenseExpiry"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
      />
      <span class="fa fa-times invalid-feedback-icon" aria-hidden="true"></span>
      @if (daysBeforeExpiry.touched && daysBeforeExpiry.invalid) { @if (daysBeforeExpiry.errors?.min) {
      <div class="invalid-feedback" id="daysBeforeLicenseExpiry-errors" role="alert">
        The Days before expiry field must be greater than or equal to 1.
      </div>
      } @if (daysBeforeExpiry.errors?.max) {
      <div class="invalid-feedback" id="daysBeforeLicenseExpiry-errors" role="alert">
        The Days before expiry field must be less than or equal to 365.
      </div>
      } @if (daysBeforeExpiry.errors?.required) {
      <div class="invalid-feedback" id="daysBeforeLicenseExpiry-errors" role="alert">
        The Days before expiry field is required.
      </div>
      } }
    </div>
  </div>
  } @if (notificationTypes.includes('OnUserPercentage')) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label for="userPercentageLimit" id="userPercentageLimitLabel" class="cs-larger-text cs-bolder-text">Mapped User Percentage Limit</label>
      <div id="userPercentageLimitSubLabel" class="cs-secondary-text">Set the percentage of mapped users to be notified at.</div>
    </div>
    <div class="cs-input-wrapper">
      <input
        type="number"
        class="form-control"
        id="userPercentageLimit"
        name="userPercentageLimit"
        #userPercentageForNotification="ngModel"
        required
        min="1"
        max="100"
        [class.is-invalid]="userPercentageForNotification.touched && userPercentageForNotification.invalid"
        cosoRangeValidator
        [attr.aria-invalid]="userPercentageForNotification.invalid"
        [attr.aria-describedby]="'userPercentageLimitSubLabel' + (userPercentageForNotification.touched && userPercentageForNotification.invalid ? ' userPercentageLimit-errors' : '')"
        [(ngModel)]="userPercentageLimit"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
      />
      <span class="fa fa-times invalid-feedback-icon" aria-hidden="true"></span>
      @if (userPercentageForNotification.touched && userPercentageForNotification.invalid) { @if (userPercentageForNotification.errors?.min) {
      <div class="invalid-feedback" id="userPercentageLimit-errors" role="alert">
        The mapped user percentage limit field must be greater than or equal to 1.
      </div>
      } @if (userPercentageForNotification.errors?.max) {
      <div class="invalid-feedback" id="userPercentageLimit-errors" role="alert">
        The mapped user percentage limit field must be less than or equal to 100.
      </div>
      } @if (userPercentageForNotification.errors?.required) {
      <div class="invalid-feedback" id="userPercentageLimit-errors" role="alert">
        The mapped user percentage limit field is required.
      </div>
      } }
    </div>
  </div>
  }
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <div id="notificationTypesLabel" class="cs-larger-text cs-bolder-text">Types of notifications</div>
      <div id="notificationTypesSubLabel" class="cs-secondary-text">Choose the notification types that you want to receive.</div>
    </div>
    <div class="cs-input-wrapper">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="error"
          name="error"
          [attr.aria-checked]="notificationTypes.includes('OnError')"
          [checked]="notificationTypes.includes('OnError')"
          (change)="setNotificationType(settings, 'OnError')"
          [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
        />
        <label class="custom-control-label" for="error"><span class="fa fa-times-circle text-danger mr-1" aria-hidden="true"></span>Errors</label>
      </div>
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="warning"
          name="warning"
          [attr.aria-checked]="notificationTypes.includes('OnWarning')"
          [checked]="notificationTypes.includes('OnWarning')"
          (change)="setNotificationType(settings, 'OnWarning')"
          [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
        />
        <label class="custom-control-label" for="warning"><span class="fa fa-exclamation-triangle text-warning mr-1" aria-hidden="true"></span>Warnings</label>
      </div>
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="expiringLicense"
          name="expiringLicense"
          [attr.aria-checked]="notificationTypes.includes('OnExpiringLicense')"
          [checked]="notificationTypes.includes('OnExpiringLicense')"
          (change)="setNotificationType(settings, 'OnExpiringLicense')"
          [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
        />
        <label class="custom-control-label" for="expiringLicense"><span class="fa fa-tags mr-1" aria-hidden="true"></span>License expiration</label>
      </div>
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="terminatingException"
          name="terminatingException"
          [attr.aria-checked]="notificationTypes.includes('OnTerminatingException')"
          [checked]="notificationTypes.includes('OnTerminatingException')"
          (change)="setNotificationType(settings, 'OnTerminatingException')"
          [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
        />
        <label class="custom-control-label" for="terminatingException"><span class="fa fa-minus-circle mr-1" aria-hidden="true"></span>Replication terminated</label>
      </div>
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="userPercentage"
          name="userPercentage"
          [attr.aria-checked]="notificationTypes.includes('OnUserPercentage')"
          [checked]="notificationTypes.includes('OnUserPercentage')"
          (change)="setNotificationType(settings, 'OnUserPercentage')"
          [disabled]="(readonly$ | async) || notificationProfileCount === 0 || !settings.notificationEmailProfileName"
        />
        <label class="custom-control-label" for="userPercentage"><span class="fa fa-tags mr-1" aria-hidden="true"></span>Mapped User Percentage limit</label>
      </div>
    </div>
  </div>
  }
</form>
